import { createAction } from 'redux-actions-helpers'
import { InviteFormType, TeacherItemType } from './types'

export const fetchTeachers = createAction('@@profile-teachers/FETCH_TEACHERS')

export const fetchTeachersSuccess = createAction(
  '@@profile-teachers/FETCH_TEACHERS_SUCCESS',
  (result: TeacherItemType[]): any => ({ result })
)

export const fetchTeachersFailure = createAction(
  '@@profile-teachers/FETCH_TEACHERS_FAILURE',
  (error: string): any => ({ error })
)

export const sendInviteTeacher = createAction(
  '@@profile-teachers/SEND_INVITE_TEACHER',
  (data: InviteFormType): any => ({ data })
)

export const sendInviteTeacherSuccess = createAction(
  '@@profile-teachers/SEND_INVITE_TEACHER_SUCCESS'
)

export const sendInviteTeacherFailure = createAction(
  '@@profile-teachers/SEND_INVITE_TEACHER_FAILURE',
  (error: string): any => ({ error })
)

export const connectTeacher = createAction(
  '@@profile-teachers/CONNECT_TEACHER',
  (short_id: string): any => ({ short_id })
)

export const connectTeacherSuccess = createAction(
  '@@profile-teachers/CONNECT_TEACHER_SUCCESS'
)

export const connectTeacherFailure = createAction(
  '@@profile-teachers/CONNECT_TEACHER_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@profile-teachers/DESTROY')
